
export const REQUEST_DELETEVIDEOTAG= 'REQUEST_DELETEVIDEOTAG';
export const DELETEVIDEOTAG_RECEIVED = 'DELETEVIDEOTAG_RECEIVED';